import { render } from "./persistent-menu.vue?vue&type=template&id=0a178b99&scoped=true"
import script from "./persistent-menu.vue?vue&type=script&lang=js"
export * from "./persistent-menu.vue?vue&type=script&lang=js"

import "./persistent-menu.vue?vue&type=style&index=0&id=0a178b99&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a178b99"]])

export default __exports__